
const Preconditions = require('./Preconditions.js'); 
const ConversationSummary = require('./ConversationSummary.js'); 

function ConversationSummaries(for_endpoint, json, labels, full_response_data)
{
    this.organization_id = null;
    this.for_endpoint = Preconditions.checkString(for_endpoint);
    this.endpoint_type = null;
    this.endpoint_sub_type = null;
    this.labels = labels;
    this.team_label = null;
    this.data = [];
    this.open_contact_request_info = {'organization_id' : null, 'employee_id' : null, 'open_contact_requests' : 0};
    this.team_count_summaries = [ { 'organization_id' : null, 'employee_id' : null, 'has_non_zero_info_for_employee' : false } ];
    this.needs_attention_counts = [];
    this.upsert(json, full_response_data);

    if ( full_response_data == null )
    {
        this.limited_by_message_privacy_controller = false;
    }
    else
    {
        this.limited_by_message_privacy_controller = full_response_data.limited_by_message_privacy_controller === true;
    }
}

ConversationSummaries.prototype.getLabels = function()
{
    return this.labels;
}

ConversationSummaries.prototype.getForEndpoint = function()
{
    return this.for_endpoint;
}

ConversationSummaries.prototype.upsert = function(json, full_response_data)
{
    Preconditions.checkNotNull(json);

    if ( full_response_data != null && full_response_data.open_contact_request_info != null )
    {
        this.open_contact_request_info = full_response_data.open_contact_request_info;
    }

    if ( full_response_data != null && full_response_data.organization_id != null )
    {
        this.organization_id = full_response_data.organization_id;
    }

    if ( full_response_data != null && full_response_data.team_conversation_counts != null )
    {
        this.team_count_summaries = full_response_data.team_conversation_counts;
    }

    if ( full_response_data != null && full_response_data.needs_attention_counts != null )
    {
        this.needs_attention_counts = full_response_data.needs_attention_counts;
    }

    if ( full_response_data != null && full_response_data.cur_employee_team_conversation_counts != null )
    {
        this.cur_employee_team_conversation_counts = full_response_data.cur_employee_team_conversation_counts;
    }

    if ( full_response_data != null && full_response_data.endpoint_type )
    {
        this.endpoint_type = full_response_data.endpoint_type;
    }

    if ( full_response_data != null && full_response_data.endpoint_sub_type )
    {
        this.endpoint_sub_type = full_response_data.endpoint_sub_type;
    }

    if ( full_response_data != null && full_response_data.team_label )
    {
        this.team_label = full_response_data.team_label;
    }

    if ( Preconditions.isArray(json) )
    {
        for ( let i = 0; i < json.length; i++ )
        {
            this.upsertOne(json[i]);
        }

        this.sort();

        return;
    }

    this.upsertOne(json);
    this.sort();
}

ConversationSummaries.prototype.sort = function(json)
{
    this.data.sort(function(a,b)
    {
        return b.getLastMessageTime() - a.getLastMessageTime();
    });
}

ConversationSummaries.prototype.upsertOne = function(json)
{
    // One summary...
    let summary = new ConversationSummary(json, this.labels);

    // Delete any existing summary
    for ( let i = 0; i < this.data.length; i++ )
    {
        if ( this.data[i].isSameConversation(summary) )
        {
            this.data[i] = summary;
            return;
        }
    }

    this.data.push(summary);
}

ConversationSummaries.prototype.length = function()
{
    return this.data.length;
}

ConversationSummaries.prototype.get = function(index)
{
    Preconditions.checkNumber(index);
    return this.data[index];
}

ConversationSummaries.prototype.findByConversationId = function(conversation_id, default_value)
{
    Preconditions.checkString(conversation_id);

    for ( let i = 0; i < this.data.length; i++ )
    {
        let summary = this.data[i];

        if ( summary.getConversationId() === conversation_id )
            return summary;
    }

    return default_value;
}

ConversationSummaries.prototype.asArray = function()
{
    let ret = [];

    for ( let i = 0; i < this.length(); i++ )
    {
        this.get(i).update();

        ret.push(this.get(i));
    }

    return ret;
}

ConversationSummaries.prototype.getOpenContactRequestInfo = function()
{
    return this.open_contact_request_info;
}

ConversationSummaries.prototype.getTeamCountSummaries = function()
{
    return this.team_count_summaries;
}

ConversationSummaries.prototype.getTeamLabel = function()
{
    return this.team_label;
}

module.exports = ConversationSummaries;

